module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/powered-by-cipherhealth-logo-cf066424855bfb2a67b05bd83aec108b.svg";